var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-file",class:_vm.inputClass},[_c('input',{staticClass:"custom-file-input",attrs:{"type":"file","id":_vm.id,"name":_vm.name}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label",attrs:{"for":_vm.id}},[_vm._v("\n        "+_vm._s(_vm.$t(_vm.placeholder))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75718a74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/form/inputs/FileComponent.vue
// module id = null
// module chunks = 